// components/layout/MobileMenu.tsx
"use client";

import Link from "next/link";
import {MAIN_NAV} from "@/shared/pages/menus";
import ExportedImage from "next-image-export-optimizer";

interface MobileMenuProps {
	isMobileMenu: boolean;
	handleMobileMenu: () => void;
}

export default function MobileMenu({
									   isMobileMenu,
									   handleMobileMenu,
								   }: MobileMenuProps) {
	return (
		<div
			className={`mobile-header-active mobile-header-wrapper-style button-bg-2 ${
				isMobileMenu ? "sidebar-visible" : ""
			}`}
		>
			<div className="mobile-header-wrapper-inner">
				<div className="mobile-header-logo">
					<Link
						className="navbar-brand d-flex main-logo align-items-center"
						href="/"
						onClick={handleMobileMenu}
					>
						<ExportedImage
							placeholder="empty"
							src="/assets/imgs/new/main/icon.svg"
							alt="The Sixth Hammer"
							width={32}
							height={32}
						/>
					</Link>

					<div
						className={`burger-icon burger-icon-white border rounded-3 ${
							isMobileMenu ? "burger-close" : ""
						}`}
						onClick={handleMobileMenu}
					>
						<span className="burger-icon-top" />
						<span className="burger-icon-mid" />
						<span className="burger-icon-bottom" />
					</div>
				</div>

				<div className="mobile-header-content-area">
					<nav>
						<ul className="mobile-menu font-heading ps-0">
							{MAIN_NAV.map((item) => (
								<li key={item.href} className="mb-2">
									<Link
										href={item.href}
										className="d-block py-2 fw-bold"
										onClick={handleMobileMenu}
									>
										{item.label}
									</Link>
								</li>
							))}
						</ul>
					</nav>
				</div>
			</div>
		</div>
	);
}
